module.exports = __webpack_public_path__ + "media/assets/images/flags/bn-31b97cd148b5f37a1628e9c634c32474.svg";